// extracted by mini-css-extract-plugin
export var wrapper = "Logo-module--wrapper--7XhQP";
export var content = "Logo-module--content--Lr1wo";
export var logo = "Logo-module--logo--h1hnz";
export var footer = "Logo-module--footer--A-0Y4";